module.exports = "/_next/static/images/game-3-fingerprint-part-1-wrong-6b5cc1831a80f8065cc7000ba1d9104c.png";